import { takeEvery, fork, put, all, call } from 'redux-saga/effects'

import fetch from './../../../fetch'
import {
  baseURL,
  commonHeaders,
} from './../../../../../Containers/Confiq/index'

import {
  UPDATE_CATEGORY,
  UPDATE_CATEGORY_SUCCESS,
  UPDATE_CATEGORY_ERROR,
} from './../../../actionType'

function* updateCategory({ payload }) {
  try {
    const response = yield call(fetch, {
      url: `${baseURL}/parse/classes/golfbookings/${payload.id}`,
      method: 'GET',
      headers: { ...commonHeaders },
    })

    console.log('mytestingResponse', response, response?.error)
    if (response?.error === undefined) {
      yield put({ type: UPDATE_CATEGORY_SUCCESS, payload: response })
    } else {
      yield put({ type: UPDATE_CATEGORY_ERROR, payload: response.error })
    }
  } catch (error) {
    yield put({ type: UPDATE_CATEGORY_ERROR, payload: error })
  }
}

export function* watchUpdateCategory() {
  yield takeEvery(UPDATE_CATEGORY, updateCategory)
}

function* updateCategorySaga() {
  yield all([fork(watchUpdateCategory)])
}

export default updateCategorySaga
